import { BANK_ACCOUNTS } from "../pharmacyTypeDefs";
import { useQuery } from "@apollo/client";

export type BuyerBankAccountRow = {
  id: number;
  accountId?: string | null;
  accountHolderName?: string | null;
  bankName?: string | null;
  last4?: string | null;
  status?: string | null;
  object?: string | null;
  routingNumber?: string | null;
  hostedVerificationUrl?: string | null;
  customer?: string | null;
};

export const deriveBuyerPaymentAccounts = (
  rows: BuyerBankAccountRow[] | null | undefined
) => {
  const accounts = rows || [];
  const achAccount =
    accounts.find(
      (item) => item.object === "payment_method" && Boolean(item.accountId)
    ) || null;
  const cardAccount =
    accounts.find((item) => item.object === "card" && Boolean(item.accountId)) ||
    null;
  return { achAccount, cardAccount, accounts };
};

export const useQueryBankAccounts = (options?: any): any =>
  useQuery(BANK_ACCOUNTS, options);
